/**
 * 品名合规检查结果映射到货品行（按列表下标对齐）。
 */
export function applyGoodsRiskToRows(goodsRows, checkData, setFn) {
  const set = setFn || ((obj, k, v) => { obj[k] = v })
  const items = (checkData && checkData.items) || []
  const list = goodsRows || []
  for (let i = 0; i < list.length; i++) {
    const it = items[i]
    const hit = !!(it && it.hit)
    const labels = []
    const advices = []
    if (hit && it.hits) {
      it.hits.forEach((h) => {
        ;(h.tagLabels || []).forEach((lb) => {
          if (lb && labels.indexOf(lb) < 0) labels.push(lb)
        })
        if (h.advice && advices.indexOf(h.advice) < 0) advices.push(h.advice)
      })
    }
    set(list[i], '_riskHit', hit)
    set(list[i], '_riskLabels', labels)
    set(list[i], '_riskTip', advices.join('；'))
  }
  return !!(checkData && checkData.hit)
}

export function buildGoodsRiskConfirmLines(checkData) {
  const lines = []
  ;((checkData && checkData.items) || []).forEach((it) => {
    if (!it || !it.hit) return
    ;(it.hits || []).forEach((h) => {
      lines.push(
        `${it.name || it.ename || ''}：${(h.tagLabels || []).join('/')}${h.advice ? ' — ' + h.advice : ''}`
      )
    })
  })
  if (!lines.length && checkData && checkData.message) {
    lines.push(checkData.message)
  }
  return lines
}
